import { AppBskyActorProfile, AppBskyLabelerService } from "@atproto/api";
import { getRecord, GetRecordOpts } from "./getRecord";

export function getProfile(did: string, opts: GetRecordOpts<AppBskyActorProfile.Record>) {
  const atUriString = `at://${did}/app.bsky.actor.profile/self`;
  opts.isValidRecord ??= AppBskyActorProfile.isRecord;
  return getRecord<AppBskyActorProfile.Record>(atUriString, opts);
}
